export class SendMailToPatient {
    email?: string;
}